import { render, staticRenderFns } from "./Query.vue?vue&type=template&id=c6505a54&scoped=true"
import script from "./Query.vue?vue&type=script&lang=js"
export * from "./Query.vue?vue&type=script&lang=js"
import style0 from "./Query.vue?vue&type=style&index=0&id=c6505a54&prod&scoped=true&lang=css"
import style1 from "./Query.vue?vue&type=style&index=1&id=c6505a54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6505a54",
  null
  
)

export default component.exports